"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSymbols = ["", "k", "M", "G", "T", "P", "E"];
